/**
 * DEVELOPMENT STUBS
 *
 * These constants contain hardcoded data used during development.
 * They will be replaced by API calls when restaurant data endpoints are wired.
 */

// TODO: Replace with restaurant.experiences from API
export const MOCK_EXPERIENCES = [
  { id: "exp1", title: "Full Premium Wine Tasting at Sunset" },
  { id: "exp2", title: "Chef's Table Dining Experience" },
  { id: "exp3", title: "Vineyard Tour & Picnic" },
];

// TODO: Replace with restaurant.experienceDetails from API
export const MOCK_EXPERIENCE_DETAILS = [
  {
    id: "exp1",
    title: "Full Premium Wine Tasting at Sunset",
    description:
      "Experience our finest selection of wines as the sun sets over the vineyard. Includes a guided tour and tasting of 6 premium wines.",
    price: "ARS 12,500",
    image: "/lovable-uploads/93cd59c1-2025-452e-bf8c-129e9e3189ed.png",
    availability: "available" as const,
  },
  {
    id: "exp2",
    title: "Chef's Table Dining Experience",
    description:
      "An intimate dining experience with our executive chef. Enjoy a custom 5-course meal paired with our award-winning wines.",
    price: "ARS 18,000",
    image: "/lovable-uploads/f23de517-a254-4426-a264-88b34a7b40c3.png",
    availability: "available" as const,
  },
  {
    id: "exp3",
    title: "Vineyard Tour & Picnic",
    description:
      "Tour our historic vineyard followed by a gourmet picnic among the vines with a bottle of wine of your choice.",
    price: "ARS 9,500",
    image: "/lovable-uploads/da6cb9d9-363f-435c-bb1c-023e68865f38.png",
    availability: "sold_out" as const,
  },
];
